export const selectShowModal = (state) => state?.modal?.shouldShowModal;
